import { z } from 'zod';

import { schemaGeneralEventApiResponse } from './GeneralResponse';

export const schemaLegitimationChanged = schemaGeneralEventApiResponse.merge(
    z.object({
        payload: z.object({
            legitimation: z.boolean(),
        }),
        type: z.literal('KreditDE_LoanRequest_LegitimationChanged'),
    }),
);

export const schemaLegitimationEventApiResponse = z.discriminatedUnion('type', [schemaLegitimationChanged]);

export type LegitimationEventApiResponse = z.infer<typeof schemaLegitimationEventApiResponse>;
export type LegitimationChanged = z.infer<typeof schemaLegitimationChanged>;
